import React from 'react'

export default function GridBanner1() {
  return (
    <div>
        <section className='mt-3'>
            <img src="/images/equipment.png" alt="" style={{ width: '100%' }}/>
        </section>
    </div>
  )
}
